import { IonPage } from '@ionic/react';
import classNames from 'classnames';

import PepperLogo from '@/assets/imgs/pepper-logo.svg';

import styles from './PrivacyPolicy.module.scss';

export const PrivacyPolicy = () => (
  <IonPage>
    <div className={styles.policyContainer}>
      <header className={styles.policyHeader}>
        <span>
          POLÍTICA DE PRIVACIDAD Y COOKIES DE PEPPER COMERCIOS (v.2023.09.19)
        </span>
        <img src={PepperLogo} alt="Pepper Logo" />
      </header>
      <h1 className={styles.policyTitle}>
        POLÍTICA DE PRIVACIDAD DE LA WEB PEPPER COMERCIOS
      </h1>
      <h2 className={styles.policySubtitle}>¿Qué es PEPPER?</h2>
      <p>
        PEPPER es la marca con la que opera la sociedad de responsabilidad
        limitada española “PEPPER FINANCE CORPORATION, S.L.U.”, provista de
        CIF/NIF nº B-86961612, y con domicilio social en la calle Juan
        Esplandiú, número 13, planta C1, C.P. 28007, Madrid (España). Inscrita
        en el Registro Mercantil de Madrid, al Tomo 32.039, Folio 211, Sección
        8ª; Hoja M-576.566, con el fin de ofrecerte, entre otros propósitos,
        esta WEB, (en adelante, “PEPPER COMERCIOS” o la “WEB”).
      </p>
      <p>
        PEPPER COMERCIOS es la solución más rápida y sencilla para gestionar
        todas tus operaciones hasta 10.000€ a golpe de clic.
      </p>
      <p>
        PEPPER COMERCIOS está pensada para facilitar el acceso al estado de
        las operaciones de los comercios que operan con Pepper.
      </p>
      <p>
        En apenas unos segundos podrás gestionar financiaciones activas,
        aprobar nuevas, retomar operaciones, tramitar devoluciones. Además,
        puedes consultar el informe de tus operaciones, configurar tu perfil y
        formarte con los artículos y las píldoras de video que ponemos a tu
        disposición para ayudarte a sacar el máximo potencial a tu negocio.
      </p>
      <p>
        Pepper es un líder global en servicios financieros especializado en
        financiación inteligente y responsable. Desde su creación en Australia
        en el año 2000, la multinacional apuesta por la tecnología y el
        análisis de datos para ofrecer soluciones personalizadas a más de 2,7
        millones de clientes en 13 países: Irlanda, Reino Unido, España,
        Grecia, India, Singapur, Australia, Nueva Zelanda, Indonesia,
        Filipinas, China, Corea del Sur y Japón.
      </p>
      <p>
        Pepper impulsa a las marcas y puntos de venta online y offline a
        través de soluciones de financiación innovadoras y adaptadas a las
        necesidades de sus clientes. pepperfinance.es
      </p>
      <h2 className={styles.policySubtitle}>INTRODUCCIÓN</h2>
      <p>
        Has aceptado la presente Política de Privacidad de PEPPER COMERCIOS
        junto con el Aviso Legal y Términos de Uso de PEPPER COMERCIOS con
        ocasión de la utilización de PEPPER COMERCIOS.
      </p>
      <h2 className={styles.policySubtitle}>
        POLÍTICA DE PRIVACIDAD DE PEPPER COMERCIOS
      </h2>
      <p>
        Pepper recoge y trata en sus sistemas de información tus Datos
        personales (en adelante los “Datos”), por lo que en esta política
        Pepper te explicará por qué los utiliza, para qué los necesita, y los
        derechos que te asisten.
      </p>
      <h3 className={styles.policySection}>RESPONSABLE DEL TRATAMIENTO DE DATOS</h3>
      <p>
        Pepper es la entidad responsable del Tratamiento de los Datos
        facilitados por los Usuarios de PEPPER COMERCIOS.
      </p>
      <p>
        Pepper tiene su domicilio en la calle Juan Esplandiú, 13, C1, de
        Madrid, C.P. 28007; y está provista del CIF/NIF nº B-86961612. Está
        inscrita en el Registro Mercantil de Madrid al Tomo 32039, Folio 211,
        Sección 8ª, Hoja M-576566.
      </p>
      <p>
        Pepper ha designado un Delegado de Protección de Datos Personales con
        el que puedes contactar mediante correo postal al domicilio indicado
        en el párrafo anterior o mediante correo electrónico a la dirección
        {' '}
        <a className={styles.policyLink} href="mailto:dpo@peppergroup.es">
          dpo@peppergroup.es
        </a>
        .
      </p>
      <h3 className={styles.policySection}>
        ¿QUÉ DATOS TRATA PEPPER? ORIGEN Y DATOS OBJETO DE TRATAMIENTO.
      </h3>
      <p>
        En Pepper recabamos y usamos distintos datos personales sobre ti (los
        “Datos”). Dichos Datos pueden proceder de información que nos has
        proporcionado directamente en el formulario de alta y/o consulta o a
        través de tu navegación por nuestros sistemas, de información que
        hemos recogido o generado sobre ti y de información que hemos obtenido
        de otras fuentes. Es decir, serán objeto de tratamiento:
      </p>
      <ul className={styles.ticksList}>
        <li>
          Los Datos que nos hayas facilitado directamente o a través del
          Formulario situado en el la web de alta automática de
          intermediarios, (incluidos los proporcionados por tu historial de
          navegación en nuestras páginas web, las grabaciones telefónicas de
          las conversaciones mantenidas, etc.); y
        </li>
        <li>
          Otros Datos recabados de fuentes de acceso público sin
          restricciones, así como Datos publicados en relación contigo.
        </li>
      </ul>
      <h3 id="data-treatment-section">
        ¿PARA QUÉ TRATAMOS LOS DATOS? FINALIDADES DE LOS DATOS Y BASES DE
        LEGITIMACIÓN
      </h3>
      <p>
        Para proceder al registro, acceso y posterior uso de PEPPER COMERCIOS,
        el Usuario deberá facilitar -de forma voluntaria-, datos de carácter
        personal, y profesional (esencialmente, identificativos y de
        contacto), los cuales serán incorporados a soportes automatizados
        titularidad de Pepper.
      </p>
      <p>
        La recogida, almacenamiento, modificación, estructuración y en su
        caso, eliminación, de los datos proporcionados por los Usuarios de
        PEPPER COMERCIOS, constituirán operaciones de tratamiento llevadas a
        cabo por Pepper, con la finalidad de garantizar el correcto
        funcionamiento de PEPPER COMERCIOS, mantener con tu comercio una
        relación de prestación de financiación, servicios y/o comercial y para
        la gestión, administración, información, prestación y mejora de los
        servicios de PEPPER COMERCIOS.
      </p>
      <p>
        Los Datos facilitados por el Usuario -especialmente, el correo
        electrónico o e-mail podrán emplearse también para remitir
        comunicaciones comerciales de promociones y/o publicidad de Pepper
        siempre y cuando, el Usuario haya prestado previamente su
        consentimiento expreso para la recepción de estas comunicaciones vía
        electrónica.
      </p>
      <p>
        De forma más específica pasamos a explicar para qué tratamos tus datos
        y cuál es la legitimación de Pepper para hacerlo:
      </p>
      <table className={classNames(styles.policyTable, styles.dataTreatmentTable)}>
        <tr>
          <th>
            <div>¿Para qué tratamos los datos?</div>
            <div>Finalidades del tratamiento de datos.</div>
          </th>
          <th>
            <div>¿Por qué podemos tratar los datos?</div>
            <div>Legitimación para el tratamiento de datos.</div>
            {' '}
          </th>
        </tr>
        <tr>
          <td>
            Para gestionar el registro, acceso y uso requerido de PEPPER
            COMERCIOS.
          </td>
          <td>
            <div>Ejecución del contrato.</div>
            <div>Consentimiento de los usuarios.</div>
          </td>
        </tr>
        <tr>
          <td>
            Pepper trata los Datos de los Usuarios para tramitar gestionar las
            solicitudes de crédito, que a través de tu establecimiento se
            realicen.
          </td>
          <td>
            <div>Ejecución del contrato</div>
            <div>Consentimiento de los Usuarios.</div>
            <div>Obligación legal.</div>
          </td>
        </tr>
        <tr>
          <td>
            Una vez concedido el crédito, Pepper tratará los Datos de los
            Usuarios para mantener y ejecutar cualquiera trámite del acuerdo
            comercial entre ambas partes que pudiera realizarse desde PEPPER
            COMERCIOS (contabilidad, giro de recibos, cobros, cargos,
            comunicaciones y notificaciones, etc.).
          </td>
          <td>
            <div>Ejecución del contrato.</div>
            <div>Consentimiento de los Usuarios.</div>
          </td>
        </tr>
        <tr>
          <td>
            Pepper tratará los Datos para dar cumplimiento a sus obligaciones
            legales tanto en materia de prevención del blanqueo de capitales
            como en materia de contabilidad mercantil general, etc.
          </td>
          <td>Obligación legal.</td>
        </tr>
        <tr>
          <td>
            Pepper tratará los Datos de navegación para analizar tus
            preferencias y mejorar nuestros productos y servicios.
          </td>
          <td>
            <div>Consentimiento de los Usuarios.</div>
            <div>
              Interés legítimo de Pepper en mejorar sus productos y servicios.
            </div>
          </td>
        </tr>
      </table>
      <h3 className={styles.policySection}>
        ¿A QUIÉN COMUNICAMOS LOS DATOS? DESTINATARIOS DE LOS DATOS.
      </h3>
      <p>Los Datos serán comunicados:</p>
      <ul className={styles.ticksList}>
        <li>
          A empresas del grupo Pepper,
          <p>
            Pepper comunicará los Datos a empresas del grupo Pepper y, entre
            ellas, a
          </p>
          <p>
            Pepper Assets Services, S.L.U. es además encargado del tratamiento
            de Datos para todas las actividades de Pepper, al ser la entidad
            que administra sus servicios de información y los créditos
            concedidos.
          </p>
        </li>
        <li>
          A los encargados del tratamiento que presten servicios a Pepper,
          <p>
            Además de a Pepper Assets Services, S.L.U., Pepper comunicará los
            Datos a otros encargados del tratamiento por razón de los
            distintos servicios que éstos le presten. Algunos ejemplos son (i)
            servicios de captación de información o cotejo de Datos, (ii)
            subcontratas informáticas o servicios de alojamiento virtual de
            Datos (“Datos en la nube”), (iii) herramientas de gestión y
            administración de créditos y otros productos financieros, (iv)
            entidades de crédito y entidades de pago para el giro de adeudos
            domiciliados o (v) proveedores de servicios de pago para la
            tramitación de transferencias o pagos por tarjeta (incluyendo
            proveedores de terminal punto de venta o “tpv”), etc.
          </p>
          <p>
            Con el fin de garantizar la confidencialidad y secreto de los
            Datos, Pepper suscribe con todos sus encargados del tratamiento un
            contrato que recoge las obligaciones de los encargados respecto
            del tratamiento de Datos de tal forma que Pepper disponga del
            control necesario sobre el tratamiento de los Datos y que sus
            encargados mantengan un nivel adecuado de protección.
          </p>
        </li>
        <li>
          A otras entidades o empresas: oferentes de servicios relacionados
          con los servicios de Pepper, o potenciales cesionarios del crédito
          en caso de ser cedido.
        </li>
        <p>
          En concreto, Pepper también comunicará los Datos a otras entidades,
          con distintos propósitos:
        </p>
        <ul className={styles.bulletPointList}>
          <li>
            A entidades de servicios de información crediticia, para efectuar
            el estudio de solvencia inicial y seguimiento de riesgos durante
            la vigencia del contrato.
          </li>
          <li>
            A determinadas autoridades o corporaciones públicas como, el
            Servicio Ejecutivo de Prevención del Blanqueo de Capitales –
            SEPBLAC o el Banco de España, los registros de la propiedad
            (Registro Nacional de Numeración de las Telecomunicaciones), entre
            otros, para dar cumplimiento a sus obligaciones legales; o
          </li>
          <li>
            A los Tribunales de justicia, el Ministerio Fiscal, y/o
            administraciones públicas competentes u otras autoridades, en caso
            de requerimiento que requiera el tratamiento y/o comunicación de
            sus Datos.
          </li>
        </ul>
      </ul>
      <h3 className={styles.policySection}>
        ¿DURANTE CUÁNTO TIEMPO CONSERVAMOS TUS DATOS PERSONALES?
      </h3>
      <p>
        Conservaremos tus Datos personales durante la vigencia de la relación
        contractual o mientras resulten necesarios para cada finalidad del
        tratamiento según hemos descrito en el apartado
        <a className={styles.policyLink}>
          {' '}
          ¿PARA QUÉ TRATAMOS LOS DATOS? FINALIDADES DEL TRATAMIENTO.
        </a>
        {' '}
        Una vez que proceda su supresión por haberse agotado la finalidad para
        la que fueron recogidos, mantendremos únicamente aquellos Datos que
        sean necesarios para el cumplimiento de las acciones legales,
        debidamente bloqueados y protegidos durante un plazo máximo de diez
        años desde la supresión.
      </p>
      <h3 className={styles.policySection}>
        ¿CUÁLES SON LOS DERECHOS SOBRE TUS DATOS?
      </h3>
      <p>
        En todo momento puedes controlar el tratamiento que hacemos de tus
        Datos y para ello tienes derecho, entre otros, a acceder, actualizar o
        rectificar o suprimir los Datos que tenemos sobre ti u otras acciones
        para el mejor control de tu privacidad. En caso de disconformidad con
        la actuación de Pepper, también podrás interponer una reclamación ante
        la autoridad de control.
      </p>
      <p>
        Mediante escrito a nuestra dirección postal o a la dirección
        electrónica
        <a
          className={styles.policyLink}
          href="mailto:protecciondatos@peppergroup.es"
        >
          {' '}
          protecciondatos@peppergroup.es
          {' '}
        </a>
        podrás ejercitar tus derechos en materia de protección de Datos, entre
        ellos:
      </p>
      <ul className={styles.ticksList}>
        <li>
          Solicitar tu acceso a los Datos y así obtener una copia de tus Datos
          personales que son objeto de tratamiento
        </li>
        <li>
          Solicitar tu rectificación o actualización por ejemplo por ser
          inexactos o estar desactualizados;
        </li>
        <li>
          Solicitar tu supresión por no ser ya necesarios para la finalidad
          para la que se recogieron;
        </li>
        <li>
          Solicitar la limitación de su tratamiento; para el caso en que hayas
          impugnado la exactitud de tus Datos, durante el plazo que nos
          permita su verificación, o incluso cuando te hayas opuesto al
          tratamiento de tus Datos personales que realizamos en base al
          interés legítimo o misión de interés público, mientras verificamos
          si estos motivos prevalecen sobre los tuyos
        </li>
        <li>
          Oponerte a uno o varios tratamientos de tus Datos en función de tus
          circunstancias específicas.
        </li>
        <li>
          Solicitar la portabilidad de tus Datos, esto es, recibir en formato
          electrónico, los Datos personales que nos hayas facilitado o, de ser
          técnicamente posible, que sean transferidos a un tercero.
        </li>
      </ul>
      <p>
        Pepper analizará y tramitará tu solicitud dándole respuesta dentro del
        plazo legalmente establecido, de un mes. En todo caso, ten en cuenta
        que la solicitud será analizada considerando las circunstancias de la
        petición de cada Titular (si es cliente o solicitante de servicios,
        visitante de la página web, etc.).
      </p>
      <p>
        En determinadas circunstancias, a pesar de tu solicitud de supresión
        de Datos o de limitación del tratamiento, Pepper podrá conservar los
        Datos con el fin exclusivo de atender futuras reclamaciones o por
        imperativo legal.
      </p>
      <p>
        Además, tendrás derecho a interponer ante la autoridad de control (la
        Agencia Española de Protección de Datos) una reclamación en caso de
        disconformidad con el tratamiento de los Datos o con el no
        reconocimiento del ejercicio de tus derechos instados ante Pepper.
      </p>
      <h3 className={styles.policySection}>
        ACTUALIZACIÓN DE LA POLÍTICA DE PRIVACIDAD DE PEPPER COMERCIOS
      </h3>
      <p>
        Pepper se reserva la modificación de la presente Política de
        Privacidad de PEPPER COMERCIOS ya sea por mejora en su contenido, como
        por cambios legislativos que así lo requieran.
      </p>
      <p>
        En ese caso, te será notificado como Usuario que se ha modificado la
        presente Política de Privacidad de PEPPER COMERCIOS y se pondrá a tu
        disposición en tu perfil, en PEPPER COMERCIOS, y para el caso de que
        continúes haciendo uso de PEPPER COMERCIOS, entenderemos que aceptas
        las nuevas condiciones.
      </p>
      <h3 className={styles.policySection}>
        POLÍTICA DE COOKIES Y/O HERRAMIENTAS ADICIONALES DE PEPPER COMERCIOS.
      </h3>
      <p>
        A través de PEPPER COMERCIOS, podemos utilizar cookies y/o
        herramientas adicionales, propiedad de terceros, con finalidades
        analíticas.
      </p>
      <h3 className={styles.policySection}>
        ¿Qué son las cookies y/o herramientas adicionales?
      </h3>
      <p>
        Con el objetivo de garantizar su privacidad, le informamos que en
        PEPPER COMERCIOS podemos utilizar cookies y/o herramientas análogas y
        adicionales que nos permiten facilitarte el uso y navegación a través
        de la PEPPER COMERCIOS, garantizarte el acceso a determinadas
        funcionalidades y adicionalmente, nos ayudan a mejorar la calidad de
        la Web de acuerdo a vuestros hábitos y estilos de navegación como
        Usuarios
      </p>
      <p>
        Una cookie o cualquier herramienta de naturaleza es un fichero que se
        descarga en su terminal, (ya sea un ordenador, Smartphone o tableta)
        cuando con ocasión de la descarga de la PEPPER COMERCIOS que nos
        permite en cuanto titulares de la Web ser capaces de almacenar o
        recuperar determinada información sobre múltiples variables, como por
        ejemplo: el número de veces que has visitado la Web identificarte,
        garantizar tu sesión como Usuario mientras navegas por PEPPER
        COMERCIOS, permitir que la realización de operaciones de forma segura
        y estable, etc.…
      </p>
      <p>
        Como se ha indicado, las cookies y/o herramientas análogas y
        adicionales que pueden darse en PEPPER COMERCIOS ofrecen información
        sobre vuestros hábitos de navegación en dicha web, y en consecuencia
        pueden afectar a vuestra privacidad; por este motivo, desde Pepper
        queremos ofrecerte la información necesaria sobre la tipología de
        cookies y/o herramientas análogas adicionales que se pueden dar en
        PEPPER COMERCIOS, para que tengas plena capacidad de decisión en
        relación al uso de las mismas y en relación a la protección de tu
        privacidad.
      </p>
      <h3 className={styles.policySection}>
        Tipología de cookies y/o herramientas adicionales empleadas.
      </h3>
      <p>
        A continuación, te ofrecemos información sobre el tipo de cookies
        utilizadas y/o herramientas adicionales en PEPPER COMERCIOS, y la
        finalidad de las mismas:
      </p>
      <p>La relación de herramientas empleadas por PEPPER COMERCIOS es:</p>
      <table className={classNames(styles.policyTable, styles.providersTable)}>
        <tr>
          <th colSpan={2}>Nombre del proveedor: Application Insights</th>
        </tr>
        <tr>
          <th>ai_session</th>
          <td>
            Se usa con Microsoft Application Insights para recopilar
            información estadística de uso y telemetría. Cookie de
            identificador de sesión anónimo único.
          </td>
        </tr>
        <tr>
          <th>ai_user</th>
          <td>
            Se usa con Microsoft Application Insights para recopilar
            información estadística de uso y telemetría. Cookie de
            identificador de usuario único para contar el número de usuarios
            que acceden a una aplicación a lo largo del tiempo.
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div>
              Si deseas más información sobre el uso de esta herramienta:
            </div>
            <a
              className={styles.policyLink}
              href="https://docs.developers.optimizely.com/digital-experience-platform/docs/cookie-usage"
            >
              https://docs.developers.optimizely.com/digital-experience-platform/docs/cookie-usage
            </a>
          </td>
        </tr>
        <tr>
          <th colSpan={2}>Nombre del proveedor: Hotjar </th>
        </tr>
        <tr>
          <th>{'_hjSessionUser_{id_del_sitio}'}</th>
          <td>
            <div>
              Se establece cuando un usuario entra por primera vez en una
              página.
            </div>
            <a
              className={styles.policyLink}
              href="https://help.hotjar.com/hc/es/articles/115011669147"
            >
              Persiste el ID de usuario de Hot jar que es único para ese
              sitio. Hotjar no rastrea usuarios en diferentes sitios.
            </a>
            <div>
              Garantiza que los datos de visitas posteriores al mismo sitio se
              atribuyan al mismo ID de usuario.
            </div>
            <div>Duración 365 días.</div>
            <div>Tipo de datos JSON.</div>
          </td>
        </tr>
        <tr>
          <th>_hjid</th>
          <td>
            Se trata de una cookie antigua que ya no establecemos, pero si un
            usuario la tiene sin caducar en su navegador, reutilizaremos su
            valor y migraremos a
            {' '}
            {'_hjSessionUser_{site_id}'}
            .
            <div>
              Se establece cuando un usuario entra por primera vez en una
              página.
            </div>
            <a
              className={styles.policyLink}
              href="https://help.hotjar.com/hc/es/articles/115011669147"
            >
              {' '}
              Persiste el ID de usuario Hotjar que es único para ese sitio.
            </a>
            <div>
              Garantiza que los datos de visitas posteriores al mismo sitio se
              atribuyan al mismo ID de usuario.
            </div>
            <div>Duración 365 días.</div>
            <div>Tipo de datos UUID.</div>
          </td>
        </tr>
        <tr>
          <th>
            <p>_hjFirstSeen</p>
          </th>
          <td>
            <p>
              <div>Identifica la primera sesión de un nuevo usuario.</div>
              <div>
                Utilizada por los filtros de grabación para identificar nuevas
                sesiones de usuario.
              </div>
              <div>
                Duración de 30 minutos, ampliada en función de la actividad
                del usuario.
              </div>
              <div>Tipo de datos booleano verdadero/falso.</div>
            </p>
          </td>
        </tr>
        <tr>
          <th>
            <p>_hjHasCachedUserAttributes</p>
          </th>
          <td>
            <p>
              <div>
                Permite saber si los datos establecidos en el elemento de
                almacenamiento local _hjUserAttributes están actualizados o
                no.
              </div>
              <div>Duración de la sesión.</div>
              <div>Tipo de dato booleano true/false</div>
            </p>
          </td>
        </tr>
        <tr>
          <th>_hjUserAttributesHash</th>
          <td>
            <div>
              Nos permite saber cuándo algún Atributo de Usuario ha cambiado y
              necesita ser actualizado.
            </div>
            <div>Duración de 2 minutos, ampliado cada 30 segundos.</div>
            <div>Tipo de datos hash de contenido.</div>
          </td>
        </tr>
        <tr>
          <th>{'_hjSession_{id_sitio}'}</th>
          <td>
            <div>Almacena los datos de la sesión actual.</div>
            <div>
              Garantiza que las solicitudes posteriores en la ventana de
              sesión se atribuyan a la misma sesión.
            </div>
            <div>
              Duración de 30 minutos, ampliada en función de la actividad del
              usuario.
            </div>
            <div>Tipo de datos JSON.</div>
          </td>
        </tr>
        <tr>
          <th>_hjSessionTooLarge </th>
          <td>
            <div>
              Hace que Hotjar deje de recopilar datos si una sesión se vuelve
              demasiado grande.
            </div>
            <div>
              Determinado automáticamente por una señal del servidor si el
              tamaño de la sesión excede el límite.
            </div>
            <div>Duración de la sesión.</div>
            <div>Tipo de dato booleano true/false.</div>
          </td>
        </tr>
        <tr>
          <th>_hjSessionResumed </th>
          <td>
            <div>
              Se establece cuando una sesión/grabación se reconecta a los
              servidores Hotjar después de una interrupción en la conexión.
              Duración de la sesión.
            </div>
            <div>ipo de datos booleano true/false.</div>
          </td>
        </tr>
        <tr>
          <th>_hjCookieTest</th>
          <td>
            <div>
              Comprueba si el código de seguimiento Hotjar puede utilizar
              cookies. Si puede, se establece un valor de 1.
            </div>
            <div>Se elimina casi inmediatamente después de su creación.</div>
            <div>
              Por debajo de 100ms de duración, el tiempo de expiración de la
              cookie se ajusta a la duración de la sesión.
            </div>
            <div>Tipo de datos booleano true/false.</div>
          </td>
        </tr>
        <tr>
          <th>_hjLocalStorageTest</th>
          <td>
            <div>
              Comprueba si el código de seguimiento Hotjar puede utilizar el
              almacenamiento local. Si puede, se establece un valor de 1.
            </div>
            <div>
              Los datos almacenados en _hjLocalStorageTest no tienen tiempo de
              expiración, pero se borran casi inmediatamente después de su
              creación.
            </div>
            <div>La duración es inferior a 100 ms.</div>
            <div>Tipo de datos booleano true/false.</div>
          </td>
        </tr>
        <tr>
          <th>
            <p>_hjSessionStorageTest</p>
          </th>
          <td>
            <p>
              <div>
                Comprueba si el Código de Seguimiento Hotjar puede utilizar el
                Almacenamiento de Sesión. Si puede, se establece un valor de
                1.
              </div>
              <div>
                Los datos almacenados en _hjSessionStorageTest no tienen
                caducidad, pero se borran casi inmediatamente después de su
                creación.
              </div>
              <div>Duración inferior a 100ms.</div>
              <div>Tipo de datos booleano true/false.</div>
            </p>
          </td>
        </tr>
        <tr>
          <th>
            <p>_hjIncludedInPageviewSample</p>
          </th>
          <td>
            <p>
              <div>
                Establecida para determinar si un usuario está incluido en el
                muestreo de datos definido por el límite de páginas vistas de
                su sitio.
              </div>
              <div>Duración de 2 minutos, ampliada cada 30 segundos.</div>
              <div>Tipo de datos booleano true/false.</div>
            </p>
          </td>
        </tr>
        <tr>
          <th>{'_hjIncludedInSessionSample_{id_sitio}'}</th>
          <td>
            <div>
              Se establece para determinar si un usuario está incluido en el
              muestreo de datos definido por el límite de sesiones diarias de
              su sitio.
            </div>
            <div>Duración de 2 minutos, ampliada cada 30 segundos.</div>
            <div>Tipo de datos booleano true/false.</div>
          </td>
        </tr>
        <tr>
          <th>_hjAbsolute SessionInProgress </th>
          <td>
            <div>
              Utilizada para detectar la primera sesión pageview de un
              usuario.
            </div>
            <div>
              Duración 30 minutos, ampliada en función de la actividad del
              usuario.
            </div>
            <div>Tipo de datos booleano verdadero/falso.</div>
          </td>
        </tr>
        <tr>
          <th>_hjTLDTest </th>
          <td>
            <div>
              Intentamos almacenar la cookie _hjTLDTest para diferentes
              alternativas de subcadena de URL hasta que falla.
            </div>
            <div>
              Nos permite intentar determinar la ruta de cookie más genérica a
              utilizar, en lugar del nombre de host de la página.
            </div>
            <div>
              Esto significa que las cookies pueden ser compartidas a través
              de subdominios (cuando sea aplicable).
            </div>
            <div>Después de esta comprobación, la cookie se elimina.</div>
            <div>Duración de la sesión.</div>
            <div>Tipo de datos booleano verdadero/falso.</div>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div>
              Si deseas más información sobre el uso de esta herramienta:
            </div>
            <a
              className={styles.policyLink}
              href="https://help.hotjar.com/hc/es/articles/6952777582999"
            >
              https://help.hotjar.com/hc/es/articles/6952777582999
            </a>
          </td>
        </tr>
      </table>
      <h3 className={styles.policySection}>¿Quién utiliza las cookies?</h3>
      <p>
        La información que se recaba a través de las cookies y/o herramientas
        adicionales de PEPPER COMERCIOS puede ser utilizada tanto por Pepper
        en cuanto titular de la Web, como por un tercero que preste un
        servicio a Pepper, (por ejemplo, “Google”).
      </p>
      <p>Atentamente, el Equipo de Pepper.</p>
      <p>
        © PEPPER FINANCE CORPORATION, S.L.U., septiembre 2023. Todos los
        derechos reservados.
      </p>
      <footer className={styles.policyFooter}>
        “PEPPER FINANCE CORPORATION, S.L.U.”, C.I.F./N.I.F. nº B-86961612;
        calle Juan Esplandiú, nº 13, C1, C.P. 28007, Madrid, (España);
        inscrita en el Registro Mercantil de Madrid (España), al Tomo 32.039,
        Folio 211, Sección 8ª, Hoja M-576.566;
        <a className={styles.policyLink} href="https://www.pepperfinance.es">
          {' '}
          www.pepperfinance.es
        </a>
      </footer>
    </div>
  </IonPage>
);
